import React, { useEffect, useState } from 'react';
import './CommunitySubscriptions.scss';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { http, FxSelect, FxHumanDateDisplay, localstorage } from '../../fx-core';
import { NoRecords } from '../../NoRecords/NoRecords';

const CommunitySubscriptions = (props) => {

    let defaultFilter: any = {
        statusId: -1,
        communityId: props.communityId
    };
    const statusArr = [
        { id: -1, 'text': 'All' },
        { id: 1, 'text': 'Active' },
        { id: 2, 'text': 'Expired' },
    ]
    const [filters, setFilters] = useState(defaultFilter);
    const [subscriptions, setSubscriptions] = useState([]);
    const [communityList, setCommunityList] = useState([]);

    const handleInputChange = (item) => {
        handleFilterChange({ [item.name]: item.value });
        let filterObj = {
            statusId: filters.statusId,
            communityId: filters.communityId
        }
        if (item.name == "statusId") {
            filterObj.statusId = item.value;
        }
        else if (item.name == 'communityId') {
            filterObj.communityId = item.value;
        }
        getCommunitySubscriptions(filterObj);
    };

    const handleFilterChange = (data) => {
        setFilters(prevState => {
            return { ...prevState, ...data }
        });
    };

    const getCommunitySubscriptions = (data: any) => {
        let inputData = {
            ds: {
                resultset: [
                    { key: "subscriptions", type: "list" }
                ]
            },
            data: {
                communityId: data.communityId,
                statusId: data.statusId
            }
        };
        let apiOptions: any = {
            url: `general/dbo/GetCommunitySubscriptions`,
            data: inputData
        };
        http.post(apiOptions).then(res => {
            getCommunitySubscriptionsCallBack(res);
        });
    };

    const getCommunitySubscriptionsCallBack = (res) => {
        let result = res.data;
        setSubscriptions(result.subscriptions);
    }

    const getMyRegionCommunities = () => {
        let inputData = {
            lookups: {
                MyRegionCommunities: { default: false }
            },
            filters: {
                userId: localstorage.getItem("userId")
            }
        };
        let apiOptions = {
            url: 'options/lookup',
            data: inputData
        };
        http.post(apiOptions).then(response => {
            getMyRegionCommunitiesCallBack(response);
        })
    };

    const getMyRegionCommunitiesCallBack = (res) => {
        let result = res.data;
        setCommunityList(result.MyRegionCommunities);
    };

    const getMyZoneCommunities = () => {
        let inputData = {
            lookups: {
                MyZoneCommunities: { default: false }
            },
            filters: {
                userId: localstorage.getItem("userId")
            }
        };
        let apiOptions = {
            url: 'options/lookup',
            data: inputData
        };
        http.post(apiOptions).then(response => {
            getMyZoneCommunitiesCallBack(response);
        })
    }

    const getMyZoneCommunitiesCallBack = (res) => {
        let result = res.data;
        setCommunityList(result.MyZoneCommunities);
    };

    const getMyAdminCommunities = () => {
        let apiOptions: any = {
            url: 'community/role/list',
            data: {}
        };
        http.post(apiOptions).then(res => { getMyAdminCommunitiesCallBack(res) });
    };

    const getMyAdminCommunitiesCallBack = (res) => {
        let result = res.data;
        let commuArr: any = [];
        for (let item of result) {
            let itemObj: any = {
                id: item.id,
                text: item.name
            };
            commuArr.push(itemObj);
        }
        setCommunityList(commuArr);
    };

    const initCalls = () => {
        if (props.parent == 'REGIONALMANAGER') {
            getMyRegionCommunities();
        }
        else if (props.parent == 'ZONALMANAGER') {
            getMyZoneCommunities();
        }
        else if (props.parent == 'COMMADMIN') {
            getMyAdminCommunities();
        }
    }

    useEffect(() => {
        initCalls()
        getCommunitySubscriptions(filters);
    }, []);

    return (
        <div className='communitysubscriptions-ui'>
            <div className='content-container'>
                <div className="content">
                    <div className='row my-4 mx-2'>
                        <div className="col-3">
                            <FxSelect name="statusId" variant="outlined" label="Status"
                                options={statusArr}
                                selectedValue={filters.statusId}
                                valueField="id"
                                displayField="text"
                                size="small"
                                style={{ width: 260 }}
                                onValueChange={handleInputChange} />
                        </div>
                        <div className='col-3'>
                            <FxSelect name="communityId" variant="outlined"
                                label="Community"
                                options={communityList}
                                selectedValue={filters.communityId}
                                valueField="id"
                                displayField="text"
                                size="small"
                                style={{ width: 260 }}
                                onValueChange={handleInputChange} />
                        </div>
                    </div>
                    <div className='row my-4 mx-4 pt-2'>
                        <TableContainer component={Paper}>
                            <Table className="table-striped" size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Stall</TableCell>
                                        <TableCell>Community</TableCell>
                                        <TableCell>Expired on</TableCell>
                                        <TableCell>Status</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        subscriptions.length == 0 &&
                                        <TableCell colSpan={4}>
                                            <NoRecords />
                                        </TableCell>
                                    }
                                    {
                                        subscriptions.length > 0 && subscriptions.map((row: any, i) => (
                                            <TableRow key={i}>
                                                <TableCell>
                                                    {row.stallName}
                                                </TableCell>
                                                <TableCell>
                                                    {row.communityName}
                                                </TableCell>                                                
                                                <TableCell>
                                                    <FxHumanDateDisplay value={row.subscriptionEndDate} displayType="date" />
                                                </TableCell>
                                                <TableCell>
                                                    {
                                                        row.isActiveSubscription &&
                                                        <span>Active</span>
                                                    }
                                                    {
                                                        !row.isActiveSubscription &&
                                                        <span>Expired</span>
                                                    }
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default CommunitySubscriptions;